import { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
export var DEFAULT_ORDER = 1;

// resolve "order" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveStart"
// in packages/editor/adf-schema/src/schema/nodes/ordered-list.ts
export var resolveOrder = function resolveOrder(order) {
  var num = Number(order);
  if (Number.isNaN(num)) {
    return;
  }
  if (num < 0) {
    return;
  }
  return Math.floor(Math.max(num, 0));
};
export var getOrderFromMaybeOrderedListNode = function getOrderFromMaybeOrderedListNode(maybeOrderedListNode) {
  var _maybeOrderedListNode, _resolveOrder;
  if (!(maybeOrderedListNode instanceof PMNode)) {
    return DEFAULT_ORDER;
  }
  var order = maybeOrderedListNode === null || maybeOrderedListNode === void 0 || (_maybeOrderedListNode = maybeOrderedListNode.attrs) === null || _maybeOrderedListNode === void 0 ? void 0 : _maybeOrderedListNode.order;
  return (_resolveOrder = resolveOrder(order)) !== null && _resolveOrder !== void 0 ? _resolveOrder : DEFAULT_ORDER;
};